import {connect} from 'pwa-helpers';
import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {when} from 'lit/directives/when.js';
import store from '../../../store';


@customElement('solar-specsheet-head')
export class SolarSpecsheetHead extends connect(store)(LitElement) {

	static styles = [
	css`

	:host {
		margin: var(--specsheet-medium-gap) var(--specsheet-large-gap) 0 var(--specsheet-large-gap);
  	}

	.headline {
		display: flex;
		width: 100%;
	  	justify-content: space-between;
	}

	.title {
		margin: 0;
	}

	.subtitle {
		color: var(--color-black);
		text-decoration: none;
		font: var(--font-specsheet-print-light);
		margin: 0;
		text-transform: uppercase;
	}

	.family-name {
		font: var(--font-summary-paragraph);
	}


	@media print {
		:host {
			padding-bottom: var(--specsheet-small-gap);
			margin: 0;
	  	}

		.headline {
		  	display: flex;
    		width: 100%;
    		justify-content: space-between;
			box-sizing: border-box;
			margin: 0;
	  	}

		.family-name {
			font: var(--font-specsheet-print-light);
			color: var(--color-grey4);
			flex: 1;
		}

		.title {
			font: var(--font-modal-title);
			color: var(--color-black);
			margin: 0;
			line-height: 1.2;
			letter-spacing: 1px;
			flex: 4;
		}

		h2.title {
			font: var(--font-specsheet-print-title-bold);
			padding-bottom: var(--specsheet-print-small-gap);
		}

		.subtitle {
			color: var(--color-black);
			text-decoration: none;
			font: var(--font-specsheet-print-light);
			margin: 0;
			text-transform: uppercase;
		}

	}
	`
	]
	;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}


	stateChanged(state) {
		this.productData = state.productData;
		this.status = state.status;
		this.shortNumberProductModel = state.shortNumber.data.ProductModel ?? '';
	}


	render() {
		return html`
			<div class="headline">
				<div class="flex-item title">
					<h2 class="title">
						Aeto
					</h2>
					<h3 class="subtitle">
						[number]
				</h3>
				</div>
				<div class="flex-item family-name">
					<div class="family-name">
						Datenblatt
					</div>
				</div>
			</div>
		`;
	}
}
